export default "__VITE_ASSET__DG7C$Jbq__"